import { render, staticRenderFns } from "./promotion.vue?vue&type=template&id=b93ad5a0&scoped=true"
import script from "./promotion.vue?vue&type=script&lang=js"
export * from "./promotion.vue?vue&type=script&lang=js"
import style0 from "./promotion.vue?vue&type=style&index=0&id=b93ad5a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93ad5a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b93ad5a0')) {
      api.createRecord('b93ad5a0', component.options)
    } else {
      api.reload('b93ad5a0', component.options)
    }
    module.hot.accept("./promotion.vue?vue&type=template&id=b93ad5a0&scoped=true", function () {
      api.rerender('b93ad5a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/enterprise/promotion.vue"
export default component.exports